import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Backbtn from "../common/Backbtn";
import Overviewdetcard from "./Overviewdetcard";
import CustomChart from "./Charts/CustomChart";
import TokenUsedChart from "./Charts/TokenUsedChart";
import ActiveUserChart from "./Charts/ActiveUserChart";
import TotalPracticesChart from "./Charts/TotalPracticesChart";
import { calculatePercentage } from "../../utils/helper";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { getCompanyDetails } from "../../requests";
import "../../_css/Reporting.css";

const OverviewDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  
  const [overviewDetails, setOverviewDetails] = useState(null);
  const [heygenTokens, setheygenTokens] = useState(null);
  const [totalPractices, setTotalPractices] = useState(null);
  const [activeUsers, setActiveUsers] = useState(null);
  const [openAiTokens, setOpenAiTokens] = useState(null);

  const getOverviewDetails = async () => {
    dispatch(startLoader());
    try {
      const companyId = location.state?.companyId;

      if (!companyId) {
        navigate(-1);
        return;
      }

      const response = await getCompanyDetails({ company_id: companyId });
      if (response.success) {
        setOverviewDetails(response);
        setheygenTokens(response.heygenTokens);
        setTotalPractices(response.practices);
        setActiveUsers(response.activeUsers);
        setOpenAiTokens(response.openAiTokens);
      }
    } catch (error) {
      console.log("Error in getting overview details: ", error);
    } finally {
      dispatch(stopLoader());
    }
  };
  useEffect(() => {
    getOverviewDetails();
  }, []);
  return (
    <div className="admin-container">
      <div className="admin-header">
        <div className="d-flex justify-content-between">
          <span
            onClick={() => navigate(-1)}
            style={{ display: "inline-block", marginRight: "8px" }}
          >
            <Backbtn />
          </span>
          <div className="heading-text">Overview Details</div>
        </div>

        {/* <DropDown
          options={["This month", "This week", "This year"]}
          data={performancePeriod}
          setData={setPerformancePeriod}
        /> */}
      </div>
      <div className="admin-content">
        {/* donut chart and overview details card */}
        {overviewDetails && (
          <div className="di-flex" style={{ alignItems: "stretch" }}>
            <div
              style={{
                width: "25%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Overviewdetcard
                title={"Total Token Budget"}
                data={overviewDetails?.totalTokenBudget}
                desc="100 users × 10,000 token"
                color="#3B82F6"
              />
              <Overviewdetcard
                title={"Net Usage Status:"}
                data={`${overviewDetails?.usedTokens} / ${overviewDetails?.totalTokenBudget}`}
                desc="Status: 🟡 Near Limit – Monitor usage"
                color="#EAB308"
                percentage={calculatePercentage(
                  overviewDetails?.usedTokens,
                  overviewDetails?.totalTokenBudget
                )}
              />
            </div>
            <div
              className="box-con"
              style={{ width: "73%", alignItems: "center", gap: "8px" }}
            >
              <div className="heading-subtext">Cumulative Token Usage</div>
              {/* donut chart shows used and unused tokens */}
              <div style={{ width: "75%", height: "300px" }}>
                {overviewDetails && (
                  <CustomChart
                    type="doughnut"
                    xData={["Used", "Unused"]}
                    yData={[
                      overviewDetails.usedTokens,
                      overviewDetails.remainingTokens,
                    ]}
                    label="Token Usage"
                    color="#EAB308"
                    color2="#E5E7EB"
                    centerText={true}
                    sideLabels={true}
                  />
                )}
              </div>

              <div
                className="di-flex"
                style={{ justifyContent: "center", gap: "10px" }}
              >
                <div
                  className="di-flex"
                  style={{ alignItems: "center", gap: "3px" }}
                >
                  <div className="dot-graph"></div>
                  <div>
                    {"Remaining"}: {overviewDetails?.remainingTokens}
                  </div>
                </div>

                <div
                  className="di-flex"
                  style={{ alignItems: "center", gap: "3px" }}
                >
                  <div
                    className="dot-graph"
                    style={{ background: "#EAB308" }}
                  ></div>
                  <div>
                    {"Used"}: {overviewDetails?.usedTokens}
                  </div>
                </div>
              </div>
              <hr
                style={{ width: "100%", border: "1px solidrgb(128, 129, 131)" }}
              />

              <div className="overview-font">
                Caution: Slightly over monthly targets &nbsp; &nbsp; &nbsp;
                &nbsp;
              </div>
            </div>
          </div>
        )}

        {/* Bar and line chart */}
        <TokenUsedChart
          heygenTokens={openAiTokens}
          text={"OpenAI tokens used per month"}
          color="#3B82F6"
        />
        <TokenUsedChart
          heygenTokens={heygenTokens}
          text={"Lip-sync tokens used per month"}
        />
        <ActiveUserChart activeUsers={activeUsers} />
        <TotalPracticesChart practices={totalPractices} />
      </div>
    </div>
  );
};

export default OverviewDetails;
